/**
 * Catálogo do domínio `fabricacao` (T53, CAT-02).
 *
 * Origem: `src/shared/autorizacao/fabricacao.ts`.
 */
import type { Concessao, NomePapel, Papel } from "../catalogo/vocabulario";

/** `fabricacao.ts:7` concede `read` em `FABRICACAO` a qualquer autenticado, antes de papel. */
export const CONCESSOES_BASE_FABRICACAO: readonly Concessao[] = [
  { acoes: ["read"], recurso: "FABRICACAO" },
];

export const PAPEIS_FABRICACAO = {
  "fabricacao.admin": {
    dominio: "fabricacao",
    nivel: "admin",
    concessoes: [{ acoes: ["manage"], recurso: "FABRICACAO" }],
  },
  "fabricacao.escrita": {
    dominio: "fabricacao",
    nivel: "escrita",
    concessoes: [{ acoes: ["read", "write", "update", "delete"], recurso: "FABRICACAO" }],
  },
  /**
   * Sem chave em `LEGADO`: a leitura vem da base, para todo mundo. Existe porque
   * `GRUPOS.MKT` cita `fabricacao.leitura` e porque é o que resta quando a
   * leitura universal cair.
   */
  "fabricacao.leitura": {
    dominio: "fabricacao",
    nivel: "leitura",
    concessoes: [{ acoes: ["read"], recurso: "FABRICACAO" }],
  },
} as const satisfies Partial<Record<NomePapel, Papel>>;
